import { TimePicker } from "antd";
import {
  currentUser,
  getCurrentUserRole,
  levelOptions,
  roleChange,
  roles,
  ROLES_ID,
  ROLES_NAME,
  validateEmail,
  weekOptions,
} from "modules/utilities/utility";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Fade,
  Form,
  InputGroup,
  Offcanvas,
  Row,
} from "react-bootstrap";
// import { createNewUser } from "./api";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { createUser, useUserInfo, userRoles } from "./store";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import { Process, locationFilters, Teams, designationFilter, AGENT_LANGUAGES } from "../../config";
import ReactDatePicker from "react-datepicker";
import { get } from "lodash";
const CreateUser = () => {
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedTimeRange, setSelectedTimeRange] = useState([]);
  const [emailValid, setEmailValid] = useState(true);
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [email, setEmail] = useState("");
  const [breakTime, setBreaktime] = useState([]);
  const { createUserStatus } = createUser();
  const { setToaster } = useToast();
  const [show, setShow] = useState(false);
  const { roleData, getUserRoles } = userRoles();
  const currentUserLevel = secureLocalStorage.getItem("level");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [docType, setDocType] = useState(null);
  const [callProvider, setCallProvider] = useState(null);
  const [location, setLocation] = useState(null);
  const [process, setProcess] = useState(null);
  const [team, setTeam] = useState(null);
  const [date, setDate] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState(null);

  const { fetchUserData, userData } = useUserInfo();
  useEffect(() => {
    getUserRoles();
  }, []);
  const handleTimeRangeChange = (timeRange) => {
    setSelectedTimeRange(timeRange);
    let startTime;
    let endTime;
    if (timeRange) {
      startTime = moment(timeRange[0]?.$d).format("HH:mm");
      endTime = moment(timeRange[1]?.$d).format("HH:mm");
      setBreaktime([startTime, endTime]);
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    setValidated(true);
    if (form.checkValidity() === false) {
      return;
    } else {
      setValidated(true);
      const formData = {
        firstName: get(form, "elements.FirstName.value", ""),
        email: get(form, "elements.Email.value", ""),
        password: get(form, "elements.password.value", ""),
        altEmail: get(form, "elements.altEmail.value", ""),
        role: get(form, "elements.Role.value", ""),
        description: get(form, "elements.Description.value", ""),
        gender: get(form, "elements.gender.value", ""),
        tip: get(form, "elements.Tip.value", ""),
        phoneNumber: get(form, "elements.Phone.value", ""),
        level: get(form, "elements.Level.value", ""),
        type: get(form, "elements.Type.value", ""),
        team: team,
        reporting_manager: get(form, "elements.rmName.value", ""),
        designation: get(form, "elements.Designation.value", ""),
        house: get(form, "elements.House.value", ""),
        location: location,
        process: process,
        call_provider: callProvider,
        doj: date,
        week_off: get(form, "elements.Weekoffs.value", ""),
        current_status: get(form, "elements.current_status.value", ""),
        shift: get(form, "elements.Shift.value", ""),
        employee_id: get(form, "elements.empId.value"),
        regionalLanguage: selectedLanguage,
      };
      const phone_number = "+91" + formData.phoneNumber;
      const selectedDays = [];

      weekOptions.forEach((weekday) => {
        const checkbox = form.elements[weekday.label];
        if (checkbox && checkbox.checked) {
          selectedDays.push(weekday.value);
        }
      });
      const _user = {
        first_name: formData.firstName.trim(),
        email: formData.email.trim(),
        alternate_email: formData.altEmail.trim(),
        encrypted_password: formData.password,
        phone_number: phone_number.trim(),
        level: formData.level,
        meta: {
          bio: {
            description: formData.description
              ? formData.description.trim()
              : "",
            tip: formData.tip ? formData.tip.trim() : "",
          },
          breakWeekDays: selectedDays ? selectedDays : [],
          shifts:
            Array.isArray(breakTime) && breakTime.length > 0
              ? [
                {
                  startTime: breakTime[0],
                  endTime: breakTime[1],
                },
              ]
              : [],
        },
        house: formData.house,
        gender: formData.gender,
        location: formData.location,
        process: formData.process,
        call_provider: formData.call_provider,
        team: formData.team,
        reporting_manager: formData.reporting_manager,
        desgination: formData.designation,
        week_off: formData.week_off,
        doj: date ? moment(date).format("MM/DD/YYYY") : null,
        shift: formData.shift,
        current_status: formData.current_status,
        employee_id: formData.employee_id,
        regional_language: formData.regionalLanguage,
      };
      const userInfo = {
        user: _user,
        role: formData.role,
        type: formData?.type,
      };
      createUserStatus(userInfo, setToaster);
    }
    setShow(false);
    setValidated(false);
  };
  const handleEmailChange = (newEmail) => {
    setEmail(newEmail);
    const isValid = validateEmail(newEmail);
    setEmailValid(isValid);
    setEmailErrorMessage("please use traya.health or trayahealth.com");
  };

  const doctorType = [
    { label: "Allopathy", value: "allopathy" },
    { label: "Ayurveda", value: "ayurveda" },
  ];
  useEffect(() => {
    fetchUserData();
  }, []);
  const reportingManagersOptions = userData
    ?.filter((user) => [ROLES_NAME.TEAM_LEAD, ROLES_NAME.ADMIN].includes(roles[user.role.id]))
    .map((item) => (
      <option key={item.user.id} value={item.user.id}>
        {item.user.first_name}
      </option>
    ));
  return (
    <>
      {(secureLocalStorage.getItem("level") == "5" ||
        secureLocalStorage.getItem("level") == "1") && (
          <Button variant="primary" onClick={handleShow} className="me-2">
            Create New User
          </Button>
        )}
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        style={{ width: "40vw" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Create User</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="FirstName">
                <Form.Label>First name</Form.Label>
                <Form.Control required type="text" placeholder="First name" />
                <Form.Control.Feedback type="invalid">
                  Please provide the Name.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="Email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  required
                  type="email"
                  placeholder="email@traya.health"
                  isInvalid={!emailValid}
                  onChange={(event) => handleEmailChange(event.target.value)}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter valid email address Username should end with
                  "traya.health" or "trayahealth.com"
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            {/* <Row>
            </Row> */}
            <Row>
              <Form.Group as={Col} controlId="Phone">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  required
                  type="tel"
                  placeholder="xxxxxxxxxx"
                  name="phone"
                  pattern="[0-9]{10}"
                />
                <Form.Control.Feedback type="invalid">
                  Please enter phone number
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" placeholder="Password" required />
                <Form.Control.Feedback type="invalid">
                  Please provide a password.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            {/* <Row className="mb-3">
            </Row> */}
            <Row className="mb-3">
              <Form.Group as={Col} controlId="altEmail">
                <Form.Label>Alternate Email</Form.Label>
                <Form.Control type="email" placeholder="altEmail@mail.com" />
                <Form.Control.Feedback type="invalid">
                  Please provide an alternate Email.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="Role">
                <Form.Label>Role</Form.Label>
                <Form.Select
                  required
                  onChange={(e) => setDocType(e.target.value)}
                >
                  {roleData?.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Please select a role.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            {docType == "00000000-0000-0000-0000-000000000004" ? (
              <Row className="mb-3">
                <Form.Group as={Col} controlId="Type">
                  <Form.Label>Doctor Type</Form.Label>
                  <Form.Select required>
                    <option key="" value="">
                      Please select doctor Type
                    </option>
                    {doctorType?.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    Please select a Doctor Type.
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
            ) : null}
            <Row className="mb-3">
              <Form.Group as={Col} controlId="RegionalLanguage">
                <Form.Label>Regional Language</Form.Label>
                <Form.Select
                  required
                  onChange={(e) => setSelectedLanguage(e.target.value)}
                >
                  <option value="">Please Select a Language</option>
                  {Object.entries(AGENT_LANGUAGES).map(([key, language]) => {
                    return (
                      <option key={key} value={key}>
                        {language}
                      </option>
                    );
                  })}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Please select a regional language.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group as={Col} controlId="gender">
                <Form.Label>Gender</Form.Label>
                <Form.Select
                  required
                >
                  <option value="">Please Select a Gender</option>
                  <option value="M">Male</option>
                  <option value="F">Female</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Please select a gender
                </Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="team">
                <Form.Label>Team</Form.Label>
                <Form.Select onChange={(e) => setTeam(e.target.value)}>
                  <option value="">Please Select Team</option>
                  {Teams?.map((option) => (
                    <option key={option.name} value={option.value}>
                      {option.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>
            {team !== null && (
              <>
                <Row className="mb-3">
                  <Form.Group as={Col} controlId="House">
                    <Form.Label>House</Form.Label>
                    <Form.Select
                      required
                      onChange={(e) => setDocType(e.target.value)}
                      defaultValue="Please select House"
                    >
                      <option value="">Please Select House</option>
                      <option key={"In House"} value={"In-house"}>
                        {"In House"}
                      </option>
                      <option key={"Out Source"} value={"Outsource"}>
                        {"Out Source"}
                      </option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group as={Col} controlId="Location">
                    <Form.Label>Location</Form.Label>
                    <Form.Select
                      required
                      onChange={(e) => setLocation(e.target.value)}
                    >
                      <option value="">Please Select Location</option>
                      {locationFilters.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} controlId="Process">
                    <Form.Label>Process</Form.Label>
                    <Form.Select
                      required
                      onChange={(e) => setProcess(e.target.value)}
                    >
                      <option value="">Please Select Process</option>
                      {Process.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group as={Col} controlId="call_provider">
                    <Form.Label>Call Provider</Form.Label>
                    <Form.Select
                      required
                      onChange={(e) => setCallProvider(e.target.value)}
                    >
                      <option value="">Please Call Provider</option>
                      <option key={"voitekk"} value={"voitekk"}>
                        {"voitekk"}
                      </option>
                      <option key={"Exxotel"} value={"Exotel"}>
                        {"Exotel"}
                      </option>
                      <option key={"Self"} value={"self"}>
                        {"Self"}
                      </option>
                    </Form.Select>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} controlId="rmName">
                    <Form.Label>Reporting Manager</Form.Label>
                    <Form.Select required>
                      <option value="">Please Select Reporting Manage</option>
                      {reportingManagersOptions}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group as={Col} controlId="Designation">
                    <Form.Label>Designation</Form.Label>
                    <Form.Select required >
                      <option value="">Please Select Designation</option>
                      {designationFilter.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} controlId="doj">
                    <Form.Label>DOJ</Form.Label>
                    <ReactDatePicker
                      selected={date}
                      onChange={(date) => setDate(date)}
                      className="form-control"
                      placeholderText="Select Date"
                      dateFormat="dd-MM-yyyy"
                      locale="es"
                    />
                  </Form.Group>
                  <Form.Group as={Col} controlId="Shift">
                    <Form.Label>Shift</Form.Label>
                    <Form.Select required>
                      <option value="">Please Select the Shift timings</option>
                      <option value="10:00-19:00">10:00-19:00</option>
                      <option value="10:00-19:30">10:00-19:30</option>
                      <option value="11:30-21:00">11:30-21:00</option>
                    </Form.Select>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} controlId="empId">
                    <Form.Label>Employee id</Form.Label>
                    <Form.Control required type="text" placeholder="Employee Id" />
                    <Form.Control.Feedback type="invalid">
                      Please provide the Employee Id.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} controlId="Weekoffs">
                    <Form.Label>Week-offs</Form.Label>
                    <Form.Select
                      required
                      type="text"
                      placeholder="Week-offs"
                    >
                      <option value="">Please Select the Week Off</option>
                      <option value="Mon">Mon</option>
                      <option value="Tue">Tue</option>
                      <option value="Wed">Wed</option>
                      <option value="Thu">Thu</option>
                      <option value="Fri">Fri</option>
                      <option value="Sat">Sat</option>
                      <option value="Sun">Sun</option>
                      <option value="Rotational">Rotational</option>
                    </Form.Select>
                  </Form.Group>
                </Row>
              </>
            )}
            <Row className="mb-3">
              <Form.Group as={Col} controlId="Description">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter description"
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="Tip">
                <Form.Label>Tip</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="A tip to the user"
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="BreakDays">
                <Form.Label>Break Days</Form.Label>
                <div>
                  {weekOptions.map((weekday) => (
                    <Form.Check key={weekday.value} inline>
                      <Form.Check.Input
                        type="checkbox"
                        value={weekday.value}
                        id={weekday.label}
                      />
                      <Form.Check.Label htmlFor={weekday.value}>
                        {weekday.label}
                      </Form.Check.Label>
                    </Form.Check>
                  ))}
                </div>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="Level">
                <Form.Label>Level</Form.Label>
                <Form.Select required>
                  <option value="">Select a level...</option>
                  {levelOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
                <div className="invalid-feedback">Please select a level.</div>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="BreakTime">
                <Button
                  onClick={() => setOpen(!open)}
                  aria-controls="example-fade-text"
                  aria-expanded={open}
                  variant="falcon-primary"
                  className="mb-3"
                >
                  Add Break Timings
                </Button>
                <Fade in={open}>
                  <div id="breakTimeRangePicker" className="border rounded">
                    <TimePicker.RangePicker
                      size="middle"
                      use12Hours
                      format="HH:mm A"
                      value={selectedTimeRange}
                      onChange={handleTimeRangeChange}
                    />
                  </div>
                </Fade>
              </Form.Group>
            </Row>
            <Button type="submit">Add User</Button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default CreateUser;
